import React,{useState, useEffect} from 'react';
import {getPostById} from '../../services/servicesGetPostById';
import {Post,
    Button,
    SpanButton,
    DivPaiImage,
    DivImg,
    DivImgLiberado,
    ImgLiberado,
    LabelImageEditPost,
    InputTituloPost,
    DivTextPost,
    TextAreaTextPost,
    DivPaiImagePostLiberado,} from './StyledTemplateEdit';
import Toastify from '../../components/Toastify';
import InputFile from '../../components/inputs/inputFile/InputFile';
import {IconMdBorderColor} from '../../components/menu/styles';
import LoadScreen from '../../components/loadScreen/loadScreen'
import {UpdatePostTemplate} from '../../services/servicesUpdatePostTemplate';
import {URLIMG} from '../../helpers/constantes';
import Popup from 'reactjs-popup';
import EditorImage from '../../components/editorImage/editorImage';

export default function PostEdit(props){
    console.log(props)
    const [editorImage, setEditorImage] = useState(false)
    const [fotoCarregada, setFotoCarregada] = useState(true);
    const [conteudoPost, setConteudoPost] = useState({Id:'',
    Image1:'',
    PostText:'',
    PostTitle:'',
    Category:'',
    Date:'',
    PopularCount:'',
    KeyWords:''});

//configuração do toastify
    const customId  = 'custom-id-yes';
    const Sucess = () => Toastify.success('Salvo com Sucesso',{toastId:customId} );
    const Error = (mensagem) => Toastify.error(mensagem,{toastId:customId});

//fim configuração do toastify

    useEffect(() => {
        const newId = window.location.href.split('/');
        carregaPost(newId[newId.length - 1]);
    }, [window.location.pathname]);

    useEffect(()=>{
            setConteudoPost({...conteudoPost,Image1:conteudoPost.Image1});
            console.log(conteudoPost.Date)
    },[conteudoPost.Image1]);


    async function carregaPost(number){
        const resultPosts = await getPostById(number);
        if(resultPosts != null)
            setConteudoPost({
                    ...conteudoPost,
                    Category:resultPosts[0].Category,
                    Date:resultPosts[0].Date,
                    Id:resultPosts[0].Id,
                    Image1:URLIMG+resultPosts[0].Image1.split('/')[resultPosts[0].Image1.split('/').length - 1],
                    KeyWords:resultPosts[0].KeyWords,
                    PopularCount:resultPosts[0].PopularCount,
                    PostText:resultPosts[0].PostText,
                    PostTitle:resultPosts[0].PostTitle})
        else{
            Error('Não foi possível carregar result posts = null');
            return
        }
    }

    function dateNormalize(date){
        if(date){
            const onlyDate = date.split('T')[0];
            return onlyDate;
        }
    }

    function editaTexto(event){
        event.preventDefault();
        setConteudoPost({...conteudoPost,PostText:event.target.value});
    };

    function editaTitulo(event){
        event.preventDefault();
        setConteudoPost({...conteudoPost,PostTitle:event.target.value});
    };

   async function salvarPost(){
        try {
            const salvandoPost = await UpdatePostTemplate(conteudoPost);
            if (salvandoPost.status == 200){
                Sucess();
            }else{
                Error('Não foi possível salvar o post');
            }
        } catch (error) {
            Error('Não foi possível salvar o post catch');
        }

    }

    return(<Post>
        <DivPaiImage>
            <DivPaiImagePostLiberado>
                <div style={{height:'40px',marginBottom:'20px',display:'flex', justifyContent:'space-evenly'}}>
                    <InputFile mudaImg = {setConteudoPost}
                        imagem={conteudoPost}
                        load={fotoCarregada}
                        concluido={setFotoCarregada}/>
                    <Button onClick={()=>setEditorImage(true) }>
                        <SpanButton>Utilizar Editor</SpanButton>
                    </Button>
                </div>
                <DivImg style={{overflow:'hidden'}}>
                    <DivImgLiberado>
                        {fotoCarregada?
                            <ImgLiberado
                                id='canvas'
                                src={conteudoPost.Image1}
                            />
                        :
                            <div style={{width:'100%',height:'100%'}}><LoadScreen position='unset'/></div>
                        }
                        <LabelImageEditPost htmlFor='FotoEditaPost'style={{position:'relative',bottom:'calc(100vh * 0.35)',height:'0'}}>
                            <IconMdBorderColor style={{fontSize:'40pt'}}/>
                        </LabelImageEditPost>
                    </DivImgLiberado>
                </DivImg>
            </DivPaiImagePostLiberado>
        </DivPaiImage>
        <div style={{height:'100%',width:window.screen.width > 800 ?'50%':'100%',overflow:'hidden',marginLeft:window.screen.width > 800 ?'20px':'0',borderRadius: '0px 0px 5px 5px'}}>
            <div style={{display:'flex',height:'40px', justifyContent:'space-between'}}>
                <Button onClick={salvarPost}>
                    <SpanButton>Salvar</SpanButton>
                </Button>
                <div>
                    <span>Data do post</span>
                    <input type='date' defaultValue={dateNormalize(conteudoPost.Date)} onChange={(event)=>setConteudoPost({...conteudoPost,Date:event.target.value})} />
                </div>
            </div>
            <InputTituloPost
                value={conteudoPost.PostTitle}
                onChange={(event)=>{editaTitulo(event)}}
            />
            <DivTextPost id='divtextpost'>
                <TextAreaTextPost
                    value={conteudoPost.PostText}
                    maxLength="2200"
                    onChange={(event)=>{editaTexto(event)}}
                />
            </DivTextPost>
        </div>
        <Popup open={ editorImage } onClose={()=>setEditorImage(false)} closeOnDocumentClick={false} closeOnEscape={false} contentStyle={{backgroundColor:'#1E1E1E',borderColor:'#1E1E1E',borderRadius:'4px',width:'fit-content',height:'fit-content'}}>
                <EditorImage text={conteudoPost.PostTitle} image={conteudoPost.Image1} exibe={setConteudoPost} close={setEditorImage} save={salvarPost} />
        </Popup>
    </Post>)
}
